import {
  DataSheetGrid,
  keyColumn,
  floatColumn,
} from "react-datasheet-grid";
import { det, identity, inv } from "mathjs";
import "./App.css";
import { useState } from "react";
// this is very important to make the page even look good:
import "react-datasheet-grid/dist/style.css";

function matrix_2_dict_format(matrix) {
  // example conversion: [[1, 0], [0, 1]] => [{nr1: 1, nr2: 0}, {nr1: 0, nr2: 1}]
  // Check if the input matrix is not empty
  if (matrix.length === 0 || matrix[0].length === 0) {
    console.error("Input matrix is empty");
    return [];
  }

  // Get the number of columns in the matrix
  const numCols = matrix[0].length;

  // Perform the conversion
  const dictFormat = matrix.map((row) => {
    if (row.length !== numCols) {
      console.error("Input matrix is not rectangular");
      return {};
    }

    // Create an object with keys "nr1", "nr2", etc., based on the column index
    const rowObject = {};
    row.forEach((value, index) => {
      const key = "nr" + (index + 1);
      rowObject[key] = value;
    });

    return rowObject;
  });

  return dictFormat;
}

function dict_format_2_matrix(dictFormat) {
  // Check if the input array is not empty
  if (dictFormat.length === 0) {
    console.error("Input array is empty");
    return [];
  }

  // Get the keys of the first object to determine the number of columns
  const keys = Object.keys(dictFormat[0]);

  // Perform the conversion
  const matrix = dictFormat.map((obj) => {
    // Check if all objects have the same keys
    const objKeys = Object.keys(obj);
    if (!arraysEqual(keys, objKeys)) {
      console.error("Keys in array are not consistent");
      return [];
    }

    // Map the object values to an array
    return keys.map((key) => {
      var to_return = obj[key];
      if (to_return === null) {
        return 0;
      }
      return to_return;
    });
  });

  return matrix;
}

// Helper function to check if two arrays are equal
function arraysEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
}

/**
 * 
 * @param {number} dimensions 
 */
function createColumns(dimensions) {
  return Array.from(
    { length: dimensions },
    (_, index) => index + 1
  ).map((i) => ({ ...keyColumn("nr" + i, floatColumn), title: "A" + i }))
}

function InterActiveMatrixMath(props) {

  const { matrixdimensions } = props;

  const default_matrix = identity(matrixdimensions).toArray();

  const [current_determinante, setDeterminante] = useState(1);

  const [calculated_inverse, set_calculated_inverse] = useState(
    inv(default_matrix)
  );


  const [data, setData] = useState(matrix_2_dict_format(default_matrix));
  const columns = createColumns(matrixdimensions)


  return (
    <div
      cstyle={{
        margin: "50px",
        padding: "50px",
        maxWidth: "900px",
        background: "#f3f3f3",
      }}
    >




      <div style={{ padding: 30 + 'px' }}>
        <h3>{matrixdimensions}x{matrixdimensions}Matrix: Determinante = {current_determinante}</h3>
        <DataSheetGrid
          value={data}
          onChange={(newdata) => {
            console.log("on change has been called", newdata);
            let math_js_compatible_matrix = dict_format_2_matrix(newdata);
            //calculate determinante:
            const determinante = det(math_js_compatible_matrix);
            setDeterminante(determinante);
            if (determinante !== 0) {
              const calculated_inverse = inv(math_js_compatible_matrix);
              set_calculated_inverse(calculated_inverse);
            } else {
              set_calculated_inverse(null);
            }
            setData(newdata);
          }}
          columns={columns}
          lockRows
        />
      </div>


      <h3 style={{ padding: "10px" }} align="center">
        Inverse
      </h3>
      <div style={{ padding: "10px" }}>
        <MatrixDisplay thematrix={calculated_inverse} />
      </div>
    </div>
  );
}

function MatrixDisplay(props) {
  const { thematrix } = props;
  if (thematrix === null) {
    return (
      <p align="center" style={{ color: "red", fontWeight: "bold" }}>
        Can Not invert Singular Matrix!
      </p>
    );
  } else {
    return (
      <table border="50" align="center">
        <tbody>
          {thematrix.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((value, colIndex) => (
                <td key={colIndex}>{value}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

function App() {
  const simplearry = Array.from({ length: 9 }, (_, i) => i + 2)

  return (
    <div>

      <h1 align="center">Determinante & Inverse Calculator</h1>


      {simplearry.map((i, idx) => (<div>
        <InterActiveMatrixMath matrixdimensions={i}
        ></InterActiveMatrixMath></div>))}

    </div>
  );
}

export default App;
